import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  CreateOwnershipApiResponse,
  CreateOwnershipData,
  ViewAllocationReportApiResponse,
} from '../models/ownership.model';
import { environment } from '../../../environments/environment';

export interface ViewAllocationPayload {
  origin: string;
  commodity: string;
  flightTypes: string[];
}
@Injectable({
  providedIn: 'root',
})
export class OwnershipService {
  private readonly CREATE_OWNERSHIP_URL = `${environment.apiBaseUrl}/cafo/create-ownership`;

  private readonly UPDATE_PSEUDO_OWNERSHIP_URL = `${environment.apiBaseUrl}/cafo/updatepesudoownership`;

  constructor(private readonly http: HttpClient) {}

  createOwnership(payload: any): Observable<CreateOwnershipData> {
    return this.http
      .post<CreateOwnershipApiResponse>(this.CREATE_OWNERSHIP_URL, payload)
      .pipe(map((response) => response.data));
  }

  updatePseudoOwnership(payload: {
    origin: string;
    commodity: string;
    flightType: string;
    currentOwner: string;
    plannedOwner: string;
  }) {
    return this.http.put<any>(this.UPDATE_PSEUDO_OWNERSHIP_URL, payload).pipe(
      map((response) => response.data),
      catchError((error) => {
        return throwError(() => error);
      })
    );
  }

  viewAllocationReport(payload: { commodity: string; origin: string; flightType: string }) {
    const params = new HttpParams()
      .set('commodity', payload.commodity)
      .set('origin', payload.origin)
      .set('flighttype', payload.flightType);

    return this.http
      .get<ViewAllocationReportApiResponse>(
        `${environment.apiBaseUrl}/cafo/view-allocation-report`,
        {
          params,
        }
      )
      .pipe(map((res) => res.data));
  }
  releaseFromFlight(
    carrierCode: string,
    flightNumber: string,
    payload: {
      currentOwner: string;
      origin: string;
      flightNoSuffix?: string;
      date: string;
      time: string;
      commodityGroupCode: string;
    }
  ) {
    const finalPayload: any = { ...payload };

    if (!finalPayload.flightNoSuffix) {
      delete finalPayload.flightNoSuffix;
    }

    return this.http.put(
      `${environment.apiBaseUrl}/cafo/releasefromflights/${carrierCode}/${flightNumber}`,
      finalPayload
    );
  }

  releaseAllFlights(currentOwner: string): Observable<any> {
    const url = `${environment.apiBaseUrl}/cafo/release-all-flights`;

    const payload = {
      currentOwner,
    };

    return this.http.put(url, payload);
  }
  getAllOwnedFlights(currentOwner: string): Observable<any> {
    const url = `${environment.apiBaseUrl}/cafo/retrieveownership-all-flights`;

    return this.http.get(url, {
      params: { currentOwner },
    });
  }
}
